import "./summary.css";
import React from 'react';
import { Textfit } from 'react-textfit';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import DataGrid, { Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, Paging, Pager } from 'devextreme-react/data-grid';
import { DateBox } from 'devextreme-react';
import { SelectBox } from 'devextreme-react';
import summaryCell from './summaryNameCell.jsx';
import OperationCell from '../position/OperationCell.jsx';
import AnalyticsDownloadCell from '../analyticsManagement/analyticsDownloadCell.jsx';
import SummaryHeaderCell from "./summaryHeaderCell.jsx";
import { Button } from 'devextreme-react';



export default class Summary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            summaryItems: [],
            analyticsItems: [],            
            ioItems: [],
            currencies: [],
            rate: 0,
            profit: 0,
            profile: '-',
            yield: 0,
            fromDate: null,
            toDate: null,
            selectedCurrency: null,
            objectId: null,
            objectType: null,
            currencyName: null,
            excelDownloadButtonVisible: false
        };

        this.refreshAnalyticsData = this.refreshAnalyticsData.bind(this);
        this.refreshCurrencies = this.refreshCurrencies.bind(this);
        this.onCurrencyChanged = this.onCurrencyChanged.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.refreshInputOutput = this.refreshInputOutput.bind(this);
        this.onFromDateChanged = this.onFromDateChanged.bind(this);
        this.onToDateChanged = this.onToDateChanged.bind(this);
        this.downloadData = this.downloadData.bind(this);
    }

    onCurrencyChanged(e) {
        this.setState({ selectedCurrency: e.value })
        this.setState({ currencyName: this.state.currencies[this.state.selectedCurrency - 1].name })
        this.refreshData();
        this.refreshInputOutput();
        this.refreshAnalyticsData(); 
    }

    onFromDateChanged(e) {
        if (e.value < this.state.toDate) {
            this.setState({
                fromDate: e.value
            });

            this.refreshData();
            this.refreshInputOutput();
            this.refreshAnalyticsData(); 
        }
    }

    onToDateChanged(e) {
        if (e.value > this.state.fromDate) {
            this.setState({
                toDate: e.value
            });
            this.refreshData();
            this.refreshInputOutput();
            this.refreshAnalyticsData(); 
        }
    }

    refreshCurrencies() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/CurrencyList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ currencies: data, selectedCurrency: data[0].currencyId });
                this.setState({ currencyName: this.state.currencies[this.state.selectedCurrency - 1].name })
                this.refreshData();
                this.refreshInputOutput();
                this.refreshAnalyticsData();        
            });
    }

    refreshAnalyticsData() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/AnalyticsList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                var result = [];
                for (var i = 0; i < 5 && i < data.length; i++) {
                    result.push(data[i]);
                }
                this.setState({ analyticsItems: result });
            });
    }

    componentDidMount() {
        this.refreshCurrencies();        
    }

    refreshInputOutput() {
        var positionData = {            
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            targetCurrencyId: this.state.selectedCurrency
        };

        var tokenKey = 'accessToken';

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/summaryIO', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(positionData)
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    ioItems: data
                });
            });
    }

    refreshData() {
        var positionData = {
            objectId: 1,
            product: '',
            type: '',
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            targetCurrencyId: this.state.selectedCurrency
        }

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/Summaries', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(positionData)
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    summaryItems: data.items,
                    rate: data.rate,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    excelDownloadButtonVisible: data.excelDownloadButtonVisible
                });
            });        
    }

    downloadData() {
        var data = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            currency: this.state.currencyName,
            rate: this.state.rate,
            summaryItems: this.state.summaryItems,
            ioItems: this.state.ioItems
        }
        var tokenKey = 'accessToken';
        var token = sessionStorage.getItem(tokenKey);

        fetch('api/excel/summarydownload', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                const filename = decodeURIComponent(response.headers.get('Content-Disposition').split(';')[1].trim().split('=')[1]).replace("UTF-8''", "")
                return response.blob().then(blob => ({ filename, blob }))
            })
            .then(({ filename, blob }) => {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
            });
    }

    render() {

        return (
            <Grid fluid id="summaryGrid">
                <Row>
                    <Col lg={12}>
                        <Grid fluid className="positionInfo">
                            <Row>
                                <Col lg={4}>
                                    <Panel header="Выбор периода">
                                        <table width="100%">
                                            <tr>
                                                <td>
                                                    <DateBox value={this.state.fromDate} onValueChanged={this.onFromDateChanged} width={"auto"} id="periodFrom"></DateBox>
                                                </td>
                                                <td>
                                                    <DateBox value={this.state.toDate} onValueChanged={this.onToDateChanged} width={"auto"} id="periodTo"></DateBox>
                                                </td>
                                            </tr>
                                        </table>
                                    </Panel>
                                </Col>
                                <Col lg={2}>
                                    <Panel header="Базовая валюта">
                                        <SelectBox dataSource={this.state.currencies}
                                            displayExpr={'name'}
                                            valueExpr={'currencyId'}
                                            onValueChanged={this.onCurrencyChanged}
                                            value={this.state.selectedCurrency} />
                                    </Panel>
                                </Col>
                                <Col lg={2}>
                                    <Panel header="Оценка портфеля">
                                        <Textfit mode="multi" className="infoItem">{this.state.rate}</Textfit>
                                    </Panel>
                                </Col>
                            </Row>
                        </Grid>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <Panel header="Портфели">
                            <DataGrid className="positionGrid"
                                dataSource={this.state.summaryItems}
                                allowColumnReordering={false}
                                allowColumnResizing={true}
                                columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={false}
                            >
                                <Sorting mode={'none'} />
                                <Scrolling mode={'infinite'} />
                                <Column
                                    dataField={'name'}
                                    caption={''}
                                    cellRender={summaryCell}
                                />
                                <Column
                                    dataField={'currency'}
                                    caption={'Валюта'}
                                />
                                <Column
                                    caption={'Номер счёта'}
                                    dataField={'portfolio'}
                                    
                                />s                                
                                {/* <Column
                                    caption={'Доходность за период'}
                                    dataField={'yield'}
                                    alignment={'right'}
                                    headerCellRender={SummaryHeaderCell}                                    
                                /> */}
                                <Column
                                    dataField={'rate'}
                                    caption={'Оценка (в валюте портфеля)'}
                                    cellRender={summaryCell}
                                />
                                <Column
                                    dataField={'rateInCurrency'}
                                    headerCellRender={(e) => SummaryHeaderCell(e, this.state.currencyName)}
                                    cellRender={summaryCell}
                                />
                                <Column
                                    dataField={'percent'}
                                    caption={'Доля в портфеле'}
                                    cellRender={summaryCell}
                                />
                            </DataGrid>
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <div className="io-style">
                        <Col lg={6}>
                            <Panel header="Вводы и выводы">
                                <DataGrid
                                    dataSource={this.state.ioItems}
                                    allowColumnReordering={false}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={false}>
                                    <Paging defaultPageSize={5} />
                                    <Pager
                                        showPageSizeSelector={false}
                                        allowedPageSizes={[5]}
                                        showInfo={true} />
                                    <Column
                                        dataField={'operationDate'}
                                        caption={'Дата'}
                                        dataType={'date'}
                                    >
                                    </Column>
                                    <Column
                                        dataField={'portfolioName'}
                                        caption={'Счёт'}
                                    >
                                    </Column>
                                    <Column
                                        dataField={'currencyName'}
                                        caption={'Валюта'}
                                    >
                                    </Column>
                                    <Column
                                        dataField={'operation'}
                                        caption={'Операция'}
                                        cellRender={OperationCell}
                                    >
                                    </Column>
                                    <Column
                                        dataField={'value'}
                                        caption={'Сумма'}>
                                        <Format
                                            type="fixedPoint"
                                            precision={2}
                                        />
                                    </Column>
                                </DataGrid>
                            </Panel>
                        </Col>
                        <Button
                            text="Скачать"
                            onClick={this.downloadData}
                            visible={this.state.excelDownloadButtonVisible}
                            icon="assets/excel_logo.png"
                            type='normal'
                            elementAttr={
                                { class: "excel-download-button" }
                            }
                        />
                    </div>
                    {/*  <Col lg={6}>
                        <Panel header="Последние аналитические материалы">
                            <DataGrid
                                dataSource={this.state.analyticsItems}
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                                columnAutoWidth={true}
                                selection={{ mode: 'single' }}
                                hoverStateEnabled={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={false}
                            >
                                <Column
                                    dataField={'createDate'}
                                    caption={'Дата публикации'}
                                    dataType={'date'}
                                    width={200}
                                >
                                </Column>
                                <Column
                                    dataField={'description'}
                                    caption={'Описание'}
                                    cellRender={AnalyticsDownloadCell}>
                                </Column>
                            </DataGrid>
                        </Panel>
                    </Col>*/}
                </Row>

            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./App/containers/summary/summary.jsx